// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"7866":"012c0fd016fd8aa8","8941":"012c0fd016fd8aa8"}[chunkId] + ".css";
};